import React from 'react';

import { useIsPhone } from '@hooks';
import { ICandidatesControls } from '../controls';
import { CandidateSearch } from './CandidateSearch';
import { DesktopCandidatesToolbar } from './DesktopCandidatesToolbar';

export const CandidatesToolbar: React.FC<ICandidatesControls> = (controls) => {
  const isPhone = useIsPhone();
  const { data, view, onChange } = controls;

  return isPhone ? (
    <CandidateSearch
      fullWidth
      data={data}
      value={view.query}
      onChange={(query) => onChange({ query })}
    />
  ) : (
    <DesktopCandidatesToolbar {...controls} />
  );
};
